import {
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Stack
} from '@mui/material'
import React from 'react'

import Icon from 'components/Icon'
import { SortOrder } from 'hooks/use-stored-sorts'

type MenuItem = {
  value: string
  label: string
}

const SortMenu: React.FC<{
  onSortOrderClick(): void
  onSortMenuChange(field: string): void
  menuItems: MenuItem[]
  sortOrder: SortOrder
  sortField: string
  sortByLabel?: string
}> = ({
  onSortOrderClick,
  onSortMenuChange,
  menuItems,
  sortOrder,
  sortField,
  sortByLabel = 'Sort by'
}) => {
  return (
    <Stack alignItems="center" direction="row" gap={1}>
      <IconButton
        aria-label="sort"
        data-test-sort-order={sortOrder === 'desc' ? 'desc' : 'asc'}
        size="medium"
        onClick={onSortOrderClick}
      >
        <Icon icon={sortOrder === 'desc' ? 'solidArrowDown' : 'solidArrowUp'} />
      </IconButton>
      <FormControl css={{ minWidth: 200 }}>
        <InputLabel id="sort-by-select-label">{sortByLabel}</InputLabel>
        <Select
          data-test-sort-by
          label="Sort by"
          labelId="sort-by-select-label"
          value={sortField}
          onChange={(event) => onSortMenuChange(event.target.value)}
        >
          {menuItems?.map(({ value, label }) => {
            return (
              <MenuItem
                key={value}
                data-test-sort-menu-item={value}
                value={value}
              >
                {label}
              </MenuItem>
            )
          })}
        </Select>
      </FormControl>
    </Stack>
  )
}

export default SortMenu
